/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// utils
import LoggerUtils from "utils/logger-utils/LoggerUtils.js";

// constants
const ERROR_IMAGE_FAILED_TO_LOAD = "Failed to load image.";

class ImageUtils {

  /**
  * @param {String} imageSource
  * @returns {Promise<HTMLImageElement>}
  */
  static loadImage(imageSource) {
    return new Promise((resolve, reject) => {
      if(imageSource.naturalHeight) resolve(imageSource);
      else {
        const newImage = new Image();
        newImage.crossOrigin = true;
        newImage.onerror = (error) => {
          LoggerUtils.error(String(ERROR_IMAGE_FAILED_TO_LOAD), error, imageSource);
          reject(String(ERROR_IMAGE_FAILED_TO_LOAD));
        };
        newImage.onload = () => resolve(newImage);
        newImage.src = imageSource.src || imageSource;
      }
    });
  }

}
export default ImageUtils;
